module.exports = __webpack_public_path__ + "static/media/undraw_Wall_post_re_y78d.0816d218.svg";